"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const CodeStepup_vue_1 = tslib_1.__importDefault(require("../CodeStepup.vue"));
exports.default = vue_1.default.extend({
    name: 'email-code',
    props: {
        stepUpCategory: {
            type: Object,
            required: true,
        },
    },
    computed: {},
    methods: {},
    components: {
        CodeStepup: CodeStepup_vue_1.default,
    },
});
